"use client";

// Single-select question row: an icon, the question text, and a wrapped row
// of pill options where exactly one can be selected. Used by SurveyForm for
// every entry in _constants/surveyQuestions.js.
import { c as _c } from "react/compiler-runtime";
export default function SurveyRadioField(t0) {
  const $ = _c(20);
  const {
    icon: Icon,
    question,
    options,
    selected,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontSize: "22px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Icon) {
    t2 = <Icon sx={t1} className="mt-0.5 shrink-0 text-[--colorDisabledDisabled]" />;
    $[1] = Icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== question) {
    t3 = <p className="m3-label-large text-[--textPrimaryPrimary]">{question}</p>;
    $[3] = question;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onSelect || $[6] !== options || $[7] !== selected) {
    let t5;
    if ($[9] !== onSelect || $[10] !== selected) {
      t5 = option => {
        const isSelected = selected === option;
        return <button key={option} type="button" onClick={() => onSelect(option)} aria-pressed={isSelected} className={`m3-label-large rounded-[--radius100] px-4 py-1.5 transition-colors ${isSelected ? "bg-[--colorPrimaryOnPrimaryContainer] text-[--textPrimaryOnColorPrimary]" : "border border-[--colorOutlineOutline] text-[--textSecondarySecondary]"}`}>{option}</button>;
      };
      $[9] = onSelect;
      $[10] = selected;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = options.map(t5);
    $[5] = onSelect;
    $[6] = options;
    $[7] = selected;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <div className="flex flex-wrap gap-2">{t4}</div>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <div className="flex flex-1 flex-col gap-3">{t3}{t5}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t2 || $[18] !== t6) {
    t7 = <div className="flex items-start gap-4 py-4">{t2}{t6}</div>;
    $[17] = t2;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}